/* eslint-disable no-undef */
// eslint-disable-next-line max-classes-per-file
import { LitElement, html } from 'lit';

export class IconNybrukt extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_4530_106117)">
                    <path
                        d="M21.5 3.5L21.0937 2.8906C20.7228 2.3342 20.0983 2 19.4296 2H7C5.89543 2 5 2.89543 5 4V25C5 26.1046 5.89543 27 7 27H20C21.1046 27 22 26.1046 22 25V22"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                    />
                    <path
                        d="M6 23H21"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M12 6L15 6"
                        stroke="currentColor"
                        stroke-width="2.75"
                        stroke-linecap="round"
                    />
                    <path
                        d="M27.6931 4.58803C28.3702 3.76533 29.6298 3.76533 30.3069 4.58803L31.1823 5.65181C31.5405 6.08703 32.0918 6.31539 32.6528 6.2609L34.0241 6.12773C35.0845 6.02474 35.9753 6.91547 35.8723 7.97595L35.7391 9.34718C35.6846 9.90819 35.913 10.4595 36.3482 10.8177L37.412 11.6931C38.2347 12.3702 38.2347 13.6298 37.412 14.3069L36.3482 15.1823C35.913 15.5405 35.6846 16.0918 35.7391 16.6528L35.8723 18.0241C35.9753 19.0845 35.0845 19.9753 34.0241 19.8723L32.6528 19.7391C32.0918 19.6846 31.5405 19.913 31.1823 20.3482L30.3069 21.412C29.6298 22.2347 28.3702 22.2347 27.6931 21.412L26.8177 20.3482C26.4595 19.913 25.9082 19.6846 25.3472 19.7391L23.9759 19.8723C22.9155 19.9753 22.0247 19.0845 22.1277 18.0241L22.2609 16.6528C22.3154 16.0918 22.087 15.5405 21.6518 15.1823L20.588 14.3069C19.7653 13.6298 19.7653 12.3702 20.588 11.6931L21.6518 10.8177C22.087 10.4595 22.3154 9.90819 22.2609 9.34718L22.1277 7.97595C22.0247 6.91547 22.9155 6.02474 23.9759 6.12773L25.3472 6.2609C25.9082 6.31539 26.4595 6.08703 26.8177 5.65181L27.6931 4.58803Z"
                        stroke="currentColor"
                        stroke-width="2"
                    />
                </g>
                <path
                    d="M26 13.5L28.0211 15.3045C28.4474 15.6852 29.104 15.6381 29.4716 15.2004L33 11"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                />
                <defs>
                    <clipPath id="clip0_4530_106117">
                        <rect width="42" height="28" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-nybrukt-42')) {
    customElements.define('w-icon-nybrukt-42', IconNybrukt);
}

export class IconMittanbud extends LitElement {
    render() {
        return html`
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="45"
                height="35"
                viewBox="0 0 100 100"
                fill="none"
            >
                <path
                    fill="#101F41"
                    d="M36.002 7.003.005 43l10 10 35.997-35.997-10-10Z"
                />
                <path
                    fill="#3960BF"
                    d="M32.004 39a14.145 14.145 0 0 0 19.999 0l11.999-11.999L90 53 100 43 64.002 7.002 32.004 39.001Z"
                />
                <path
                    fill="#101F41"
                    d="M56.002 43a19.799 19.799 0 0 1-27.998 0l-14 14 35.999 35.998 6-6-14-14 4-3.999 14 14 5.999-6-14-14 4-4 14 14 6-6-14-14 4-3.999 14 14L86 57 64 35l-7.999 8Z"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-mittanbud-42')) {
    customElements.define('w-icon-mittanbud-42', IconMittanbud);
}

export class IconArtFrame extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.92291 12.375H32.0771"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.5101 20.5H31.4899"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M32.3403 17.25H26.3928C26.2523 17.25 26.1176 17.1942 26.0182 17.0948C25.9189 16.9955 25.8631 16.8607 25.8631 16.7202V16.1548C25.8631 16.0143 25.8073 15.8795 25.7079 15.7802C25.6086 15.6808 25.4738 15.625 25.3333 15.625H23.1407C23.0002 15.625 22.8654 15.6808 22.7661 15.7802C22.6667 15.8795 22.6109 16.0143 22.6109 16.1548V16.7202C22.6109 16.8604 22.5554 16.9948 22.4565 17.0941C22.3576 17.1934 22.2234 17.2494 22.0833 17.25H19.9004C19.7599 17.25 19.6252 17.1942 19.5258 17.0948C19.4265 16.9955 19.3707 16.8607 19.3707 16.7202V16.1548C19.3707 16.0852 19.357 16.0163 19.3303 15.952C19.3037 15.8878 19.2647 15.8294 19.2155 15.7802C19.1663 15.731 19.1079 15.6919 19.0436 15.6653C18.9794 15.6387 18.9105 15.625 18.8409 15.625H16.6461C16.5765 15.625 16.5076 15.6387 16.4433 15.6653C16.3791 15.6919 16.3207 15.731 16.2715 15.7802C16.2223 15.8294 16.1833 15.8878 16.1566 15.952C16.13 16.0163 16.1163 16.0852 16.1163 16.1548V16.7202C16.1163 16.7901 16.1025 16.8592 16.0757 16.9237C16.0489 16.9882 16.0095 17.0468 15.96 17.096C15.9105 17.1452 15.8517 17.1842 15.787 17.2106C15.7224 17.237 15.6532 17.2504 15.5833 17.25H9.65857"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M23.4375 1.8125V3.275C23.4375 3.82171 23.5753 4.3596 23.8384 4.83887C24.1014 5.31815 24.4811 5.72333 24.9423 6.01692L29.3644 8.83358C30.2872 9.42072 31.0468 10.2312 31.5731 11.19C32.0993 12.1487 32.3752 13.2248 32.375 14.3185V16.4375C32.375 19.0234 31.3478 21.5033 29.5193 23.3318C27.6908 25.1603 25.2109 26.1875 22.625 26.1875H19.375C16.7891 26.1875 14.3092 25.1603 12.4807 23.3318C10.6522 21.5033 9.625 19.0234 9.625 16.4375V14.3185C9.62502 13.225 9.90093 12.1491 10.4272 11.1906C10.9534 10.232 11.713 9.4217 12.6356 8.83467L17.0578 6.018C17.5191 5.72432 17.8989 5.31897 18.1619 4.83948C18.4249 4.36 18.5627 3.82189 18.5625 3.275V1.8125"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16.125 1.8125H25.875"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-vase-42')) {
    customElements.define('w-icon-vase-42', IconArtFrame);
}

export class IconAutovexLight extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_8432_13741)">
                    <path
                        d="M31.2143 1H10.7857C9.3 1 8 2.3 8 3.78571V24.2143C8 25.7929 9.3 27 10.7857 27H31.2143C32.7929 27 34 25.7 34 24.2143V3.78571C34 2.3 32.7 1 31.2143 1Z"
                        fill="#061F40"
                    />
                    <path
                        d="M15.5214 9.07861L11.9929 18.9215H14.0357L14.6857 17.0643H18.5857L19.2357 18.9215H21.2786L17.8429 9.07861H15.5214ZM15.2429 15.4858L16.6357 11.4L18.0286 15.4858H15.2429Z"
                        fill="white"
                    />
                    <path
                        d="M27.8714 9.07861L25.1786 16.8786L22.4857 9.07861H20.35L23.9714 18.9215H26.3857L30.0071 9.07861H27.8714Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_8432_13741">
                        <rect
                            width="26"
                            height="26"
                            fill="white"
                            transform="translate(8 1)"
                        />
                    </clipPath>
                </defs>
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-autovex-42')) {
    customElements.define('w-icon-autovex-42', IconAutovexLight);
}

export class IconCarFront extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M31.5625 20.7708C31.9935 20.7708 32.4068 20.5995 32.7115 20.2948C33.0163 19.9901 33.1875 19.5767 33.1875 19.1458V14.2708C33.1874 13.751 32.9809 13.2526 32.6133 12.8852L29.9375 10.2083H12.0625L9.38667 12.8841C9.20455 13.0662 9.0601 13.2823 8.96158 13.5203C8.86306 13.7582 8.8124 14.0132 8.8125 14.2708V19.1458C8.8125 19.5767 8.98371 19.9901 9.28845 20.2948C9.5932 20.5995 10.0065 20.7708 10.4375 20.7708H31.5625Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.0625 10.2083L13.9291 5.22492C14.0976 4.77888 14.398 4.39478 14.7903 4.12381C15.1826 3.85285 15.6482 3.70789 16.125 3.70825H25.875C26.3518 3.70804 26.8173 3.85306 27.2096 4.12401C27.6019 4.39495 27.9023 4.77897 28.0709 5.22492L29.9375 10.2083H12.0625Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.0625 10.2095L10.4375 8.58447H8.8125"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M29.9375 10.2095L31.5625 8.58447H33.1875"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.4375 20.7708V22.3958C10.4375 22.8267 10.6087 23.2401 10.9135 23.5448C11.2182 23.8495 11.6315 24.0208 12.0625 24.0208C12.4935 24.0208 12.9068 23.8495 13.2115 23.5448C13.5163 23.2401 13.6875 22.8267 13.6875 22.3958V20.7708H10.4375Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M31.5625 20.7708V22.3958C31.5625 22.8267 31.3913 23.2401 31.0865 23.5448C30.7818 23.8495 30.3685 24.0208 29.9375 24.0208C29.5065 24.0208 29.0932 23.8495 28.7885 23.5448C28.4837 23.2401 28.3125 22.8267 28.3125 22.3958V20.7708H31.5625Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M33.0109 13.4583H28.3125L26.3484 16.7321C26.204 16.9726 25.9998 17.1717 25.7557 17.3099C25.5115 17.4481 25.2358 17.5207 24.9552 17.5208H17.0458C16.7648 17.521 16.4885 17.4484 16.244 17.3099C15.9994 17.1715 15.7949 16.9721 15.6505 16.731L13.6875 13.4583H8.98907"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M26.3484 16.7083H33.1875"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M15.6516 16.7083H8.8125"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M28.3125 13.4583H13.6875"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-car-front-42')) {
    customElements.define('w-icon-car-front-42', IconCarFront);
}

export class IconCarPart extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M26.6355 20.5715C27.533 20.5715 28.2605 19.844 28.2605 18.9465C28.2605 18.0491 27.533 17.3215 26.6355 17.3215C25.738 17.3215 25.0105 18.0491 25.0105 18.9465C25.0105 19.844 25.738 20.5715 26.6355 20.5715Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M28.0157 12.66L28.4945 14.233C28.5733 14.4944 28.7485 14.7162 28.9846 14.8533C29.2208 14.9905 29.5002 15.0329 29.7663 14.9718L31.361 14.6013C31.6634 14.5332 31.9796 14.5637 32.2634 14.6884C32.5471 14.8131 32.7835 15.0254 32.9378 15.2941C33.0921 15.5629 33.1563 15.8741 33.1209 16.182C33.0855 16.4899 32.9525 16.7784 32.7412 17.0052L31.6253 18.2088C31.4389 18.4092 31.3353 18.6728 31.3353 18.9465C31.3353 19.2203 31.4389 19.4838 31.6253 19.6843L32.7412 20.8879C32.9528 21.1145 33.0861 21.403 33.1217 21.711C33.1572 22.019 33.0931 22.3302 32.9387 22.5991C32.7842 22.8679 32.5477 23.0802 32.2637 23.2047C31.9798 23.3292 31.6634 23.3593 31.361 23.2907L29.7663 22.9213C29.5003 22.8599 29.2209 22.902 28.9847 23.039C28.7486 23.176 28.5733 23.3976 28.4945 23.659L28.0157 25.232C27.9267 25.5289 27.7444 25.7892 27.4957 25.9742C27.2471 26.1592 26.9454 26.2592 26.6355 26.2592C26.3256 26.2592 26.0239 26.1592 25.7753 25.9742C25.5267 25.7892 25.3443 25.5289 25.2553 25.232L24.7754 23.659C24.6969 23.3977 24.5218 23.1761 24.2858 23.0391C24.0498 22.902 23.7706 22.8599 23.5047 22.9213L21.9089 23.2907C21.6068 23.3585 21.2908 23.3278 21.0074 23.2031C20.7239 23.0785 20.4878 22.8663 20.3335 22.5978C20.1793 22.3293 20.115 22.0184 20.1502 21.7108C20.1853 21.4031 20.318 21.1147 20.5288 20.8879L21.6446 19.6843C21.831 19.4838 21.9346 19.2203 21.9346 18.9465C21.9346 18.6728 21.831 18.4092 21.6446 18.2088L20.5288 17.0052C20.3175 16.7784 20.1844 16.4899 20.149 16.182C20.1136 15.8741 20.1778 15.5629 20.3321 15.2941C20.4864 15.0254 20.7228 14.8131 21.0066 14.6884C21.2903 14.5637 21.6066 14.5332 21.9089 14.6013L23.5047 14.9718C23.7707 15.0328 24.05 14.9904 24.2859 14.8533C24.5219 14.7161 24.6969 14.4943 24.7754 14.233L25.2553 12.66C25.3443 12.3631 25.5267 12.1028 25.7753 11.9178C26.0239 11.7327 26.3256 11.6328 26.6355 11.6328C26.9454 11.6328 27.2471 11.7327 27.4957 11.9178C27.7444 12.1028 27.9267 12.3631 28.0157 12.66Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M11.1417 9.3135L13.0386 5.0885C13.2128 4.62386 13.5247 4.22346 13.9326 3.94082C14.3405 3.65819 14.8249 3.50678 15.3212 3.50684H24.9433C25.4395 3.5067 25.9238 3.65809 26.3315 3.94075C26.7392 4.22341 27.0509 4.62386 27.2248 5.0885L29.125 9.31242"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M9.573 16.2913V18.1329C9.573 18.5639 9.7442 18.9772 10.0489 19.282C10.3537 19.5867 10.767 19.7579 11.198 19.7579C11.629 19.7579 12.0423 19.5867 12.347 19.282C12.6518 18.9772 12.823 18.5639 12.823 18.1329V16.5079"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.4167 12.4465C12.309 12.4465 12.2057 12.4893 12.1295 12.5655C12.0533 12.6417 12.0105 12.745 12.0105 12.8528"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.823 12.8528C12.823 12.745 12.7802 12.6417 12.704 12.5655C12.6278 12.4893 12.5245 12.4465 12.4167 12.4465"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.4167 13.259C12.5245 13.259 12.6278 13.2162 12.704 13.14C12.7802 13.0639 12.823 12.9605 12.823 12.8528"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.0084 12.8528C12.0084 12.9605 12.0512 13.0639 12.1273 13.14C12.2035 13.2162 12.3069 13.259 12.4146 13.259"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M31.075 10.8206C30.7896 10.3262 30.379 9.91572 29.8845 9.63045C29.3901 9.34519 28.8292 9.19519 28.2584 9.19556H12.0084C11.1464 9.19556 10.3198 9.53797 9.71026 10.1475C9.10077 10.757 8.75836 11.5836 8.75836 12.4456V14.8831C8.75836 15.314 8.92957 15.7274 9.23431 16.0321C9.53906 16.3369 9.95239 16.5081 10.3834 16.5081H16.8834"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-car-part-42')) {
    customElements.define('w-icon-car-part-42', IconCarPart);
}

export class IconChair extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M26.2 24.7456H15.8C13.732 24.7434 11.7493 23.9109 10.2869 22.4308C8.82461 20.9508 8.00214 18.944 8 16.8508C8 16.1529 8.27393 15.4835 8.76152 14.99C9.24912 14.4965 9.91044 14.2192 10.6 14.2192C11.2896 14.2192 11.9509 14.4965 12.4385 14.99C12.9261 15.4835 13.2 16.1529 13.2 16.8508C13.2006 17.5486 13.4747 18.2176 13.9622 18.7109C14.4497 19.2043 15.1106 19.4818 15.8 19.4824H26.2C26.8894 19.4818 27.5503 19.2043 28.0378 18.7109C28.5253 18.2176 28.7994 17.5486 28.8 16.8508C28.8 16.1529 29.0739 15.4835 29.5615 14.99C30.0491 14.4965 30.7104 14.2192 31.4 14.2192C32.0896 14.2192 32.7509 14.4965 33.2385 14.99C33.7261 15.4835 34 16.1529 34 16.8508C33.9979 18.944 33.1754 20.9508 31.7131 22.4308C30.2507 23.9109 28.268 24.7434 26.2 24.7456Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M11.4668 26.5001L12.664 24.0779"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M30.5336 26.5001L29.3364 24.0779"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M30.1796 14.5281L29.2552 4.47544C29.1293 3.64685 28.7144 2.89127 28.0857 2.34547C27.457 1.79968 26.6561 1.49976 25.8278 1.5H16.1743C15.3462 1.50004 14.5455 1.80009 13.917 2.34586C13.2886 2.89162 12.8739 3.64705 12.7481 4.47544L11.8236 14.5281"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M25.3332 15.9736V14.2192C25.3332 13.7539 25.1506 13.3077 24.8255 12.9787C24.5004 12.6497 24.0595 12.4648 23.5998 12.4648H18.3998C17.9401 12.4648 17.4992 12.6497 17.1742 12.9787C16.8491 13.3077 16.6665 13.7539 16.6665 14.2192V15.9736"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-chair-42')) {
    customElements.define('w-icon-chair-42', IconChair);
}

export class IconGuitarBat extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M21.7432 20.3256C21.6954 19.9122 21.8082 19.4962 22.0581 19.1634C22.308 18.8306 22.6761 18.6064 23.0865 18.537C23.7649 18.4336 24.3934 18.119 24.8827 17.6379C26.4698 16.0519 26.0743 13.0814 23.9954 11.0046C21.9165 8.92787 18.9482 8.53029 17.3622 10.1174C16.881 10.6066 16.5664 11.2352 16.463 11.9135C16.3936 12.3239 16.1694 12.692 15.8366 12.9419C15.5039 13.1919 15.0879 13.3046 14.6744 13.2569C13.9002 13.1383 13.1091 13.1985 12.3618 13.4329C11.6145 13.6672 10.9307 14.0695 10.3628 14.6089C8.14192 16.8297 8.58608 20.8749 11.3583 23.6417C14.1306 26.4085 18.1736 26.8549 20.3944 24.634C20.9328 24.0662 21.3341 23.3828 21.5679 22.6361C21.8017 21.8893 21.8616 21.0991 21.7432 20.3256Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M29.7408 2.9621L28.0172 4.68567C27.3826 5.32027 27.3826 6.34916 28.0172 6.98377C28.6518 7.61837 29.6807 7.61837 30.3153 6.98377L32.0389 5.26019C32.6735 4.62559 32.6735 3.5967 32.0389 2.9621C31.4043 2.32749 30.3754 2.32749 29.7408 2.9621Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M28.0168 6.98315L23.9954 11.0045"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M28.5909 1.8125L29.7404 2.96192"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M32.0381 5.25977L33.1875 6.40918"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M30.3145 6.98315L31.4639 8.13257"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M26.8673 3.53613L28.0167 4.68555"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.973 16.6521C20.8705 16.6521 21.598 15.9246 21.598 15.0271C21.598 14.1296 20.8705 13.4021 19.973 13.4021C19.0756 13.4021 18.348 14.1296 18.348 15.0271C18.348 15.9246 19.0756 16.6521 19.973 16.6521Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M13.6539 19.0483L15.9517 21.3461"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M18.283 6.69724L15.3341 3.16665C15.0111 2.76291 14.6065 2.43186 14.1467 2.19511C13.687 1.95836 13.1825 1.82125 12.6662 1.79271C12.1499 1.76418 11.6334 1.84487 11.1504 2.02952C10.6674 2.21417 10.2288 2.49862 9.86315 2.8643C9.49754 3.22998 9.21318 3.66867 9.02863 4.15171C8.84409 4.63476 8.7635 5.1513 8.79214 5.6676C8.82079 6.18391 8.95801 6.68836 9.19485 7.14803C9.4317 7.6077 9.76284 8.01224 10.1666 8.33524L12.875 10.6092"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M25.6453 21.3071L27.5108 22.8693L26.9692 23.4109C26.6643 23.7158 26.4931 24.1292 26.4931 24.5603C26.4931 24.9914 26.6643 25.4049 26.9692 25.7097C27.274 26.0146 27.6875 26.1859 28.1186 26.1859C28.5497 26.1859 28.9631 26.0146 29.268 25.7097L32.7152 22.2626C33.02 21.9577 33.1913 21.5443 33.1913 21.1132C33.1913 20.6821 33.02 20.2686 32.7152 19.9637C32.4103 19.6589 31.9969 19.4876 31.5657 19.4876C31.1346 19.4876 30.7212 19.6589 30.4163 19.9637L29.8346 20.5466L28.4349 18.875"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-guitar-bat-42')) {
    customElements.define('w-icon-guitar-bat-42', IconGuitarBat);
}

export class IconHonk28 extends LitElement {
    render() {
        return html`
            <svg
                width="28"
                height="27"
                viewBox="0 0 28 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M21.1321 0C17.6152 0 14.7642 2.85103 14.7642 6.36792C14.7642 9.88482 17.6152 12.7358 21.1321 12.7358C24.649 12.7358 27.5 9.88482 27.5 6.36792C27.5 2.85103 24.6488 0 21.1321 0ZM21.1321 9.64351C19.3231 9.64351 17.8566 8.17693 17.8566 6.36807C17.8566 4.55906 19.3231 3.09263 21.1321 3.09263C22.9409 3.09263 24.4075 4.55906 24.4075 6.36807C24.4075 8.17693 22.9409 9.64351 21.1321 9.64351Z"
                    fill="#570E2D"
                />
                <path
                    d="M10.1435 14.2637V22.5099L4.46351 14.2637H0.5V26.9997H3.59248V17.4889L10.1435 26.9997H13.236V14.2637H10.1435Z"
                    fill="#570E2D"
                />
                <path
                    d="M23.8981 26.9997H27.4999L22.3519 19.6278L27.1485 14.2637H23.652L17.8564 21.0037V14.2637H14.7639V26.9997H17.8564V24.655L20.3293 21.8895L23.8981 26.9997Z"
                    fill="#570E2D"
                />
                <path
                    d="M10.1435 0V4.99092H3.59248V0H0.5V12.736H3.59248V7.74507H10.1435V12.736H13.236V0H10.1435Z"
                    fill="#570E2D"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-honk-28')) {
    customElements.define('w-icon-honk-28', IconHonk28);
}

export class IconIceSkater extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.89569 20.5001H15.7717C16.4503 20.4995 17.1212 20.3573 17.7417 20.0825C18.3622 19.8077 18.9184 19.4064 19.3749 18.9043L21.1342 16.9695L21.9088 17.3562C22.4493 17.6258 22.904 18.0407 23.2218 18.5543C23.5396 19.0679 23.7081 19.6599 23.7082 20.2639V26.1876"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M26.9582 26.1875V20.2638C26.962 19.0642 26.6318 17.8872 26.0046 16.8645C25.3774 15.8418 24.478 15.0139 23.407 14.4734L26.5357 11.0306C26.7475 10.7976 26.887 10.5082 26.9374 10.1974C26.9877 9.88666 26.9467 9.56796 26.8193 9.28005C26.692 8.99215 26.4837 8.74745 26.2199 8.57568C25.9561 8.40391 25.648 8.31248 25.3332 8.3125H15.5832C15.1522 8.3125 14.7389 8.4837 14.4341 8.78845C14.1294 9.0932 13.9582 9.50652 13.9582 9.9375C13.9582 10.3685 14.1294 10.7818 14.4341 11.0865C14.7389 11.3913 15.1522 11.5625 15.5832 11.5625H21.6596L16.9731 16.7181C16.8208 16.8856 16.6351 17.0195 16.4281 17.1111C16.221 17.2027 15.997 17.25 15.7706 17.25H9.89569"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M30.2082 7.5C31.7788 7.5 33.0519 6.22681 33.0519 4.65625C33.0519 3.08569 31.7788 1.8125 30.2082 1.8125C28.6376 1.8125 27.3644 3.08569 27.3644 4.65625C27.3644 6.22681 28.6376 7.5 30.2082 7.5Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M30.2082 24.5625C30.2082 24.9935 30.037 25.4068 29.7322 25.7115C29.4275 26.0163 29.0142 26.1875 28.5832 26.1875H20.4582"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M11.5207 23.75C11.0897 23.75 10.6764 23.5788 10.3716 23.274C10.0669 22.9693 9.89569 22.556 9.89569 22.125V14"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M13.1457 17.25V20.5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M23.7082 22.9375H26.9582"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-ice-skater-42')) {
    customElements.define('w-icon-ice-skater-42', IconIceSkater);
}

export class IconOikotie extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.9724 24.9991H23.2543L23.255 24.9998C24.8677 24.9998 26.4197 24.3142 27.5006 23.1283L32.2517 18.0235C34.3784 15.692 34.3748 12.2308 32.256 9.98494L27.487 4.81181C26.4005 3.65976 24.8734 3 23.2964 3H16.0009C13.2431 3 11 5.25812 11 8.03441V19.9934C11 22.7539 13.231 24.9991 15.9724 24.9991ZM20.933 17.9997C18.742 17.9997 16.9594 16.2051 16.9594 13.9994C16.9594 11.7938 18.742 9.99922 20.933 9.99922C23.124 9.99922 24.9066 11.7938 24.9066 13.9994C24.9066 16.2051 23.124 17.9997 20.933 17.9997ZM20.9335 11.9995C19.8376 11.9995 18.9467 12.8964 18.9467 13.9996C18.9467 15.1028 19.8376 15.9997 20.9335 15.9997C22.0293 15.9997 22.9203 15.1028 22.9203 13.9996C22.9203 12.8964 22.0293 11.9995 20.9335 11.9995Z"
                    fill="black"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-oikotie-42')) {
    customElements.define('w-icon-oikotie-42', IconOikotie);
}

export class IconPaw extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.25 18.0625C12.5962 18.0625 13.6875 16.2437 13.6875 14C13.6875 11.7563 12.5962 9.9375 11.25 9.9375C9.90381 9.9375 8.8125 11.7563 8.8125 14C8.8125 16.2437 9.90381 18.0625 11.25 18.0625Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16.9375 9.9375C18.2837 9.9375 19.375 8.11866 19.375 5.875C19.375 3.63134 18.2837 1.8125 16.9375 1.8125C15.5913 1.8125 14.5 3.63134 14.5 5.875C14.5 8.11866 15.5913 9.9375 16.9375 9.9375Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M30.75 17.25C32.0962 17.25 33.1875 15.4312 33.1875 13.1875C33.1875 10.9438 32.0962 9.125 30.75 9.125C29.4038 9.125 28.3125 10.9438 28.3125 13.1875C28.3125 15.4312 29.4038 17.25 30.75 17.25Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M25.0625 9.9375C26.4087 9.9375 27.5 8.11866 27.5 5.875C27.5 3.63134 26.4087 1.8125 25.0625 1.8125C23.7163 1.8125 22.625 3.63134 22.625 5.875C22.625 8.11866 23.7163 9.9375 25.0625 9.9375Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M25.6843 17.9574C25.4787 17.797 25.3146 17.5896 25.2056 17.3527C25.0967 17.1158 25.0461 16.8562 25.0582 16.5957C25.0582 16.5437 25.0582 16.4873 25.0582 16.4375C25.0582 15.3601 24.6302 14.3267 23.8683 13.5649C23.1064 12.803 22.0731 12.375 20.9957 12.375C19.9182 12.375 18.8849 12.803 18.123 13.5649C17.3612 14.3267 16.9332 15.3601 16.9332 16.4375C16.9332 16.4906 16.9332 16.5458 16.9332 16.5957C16.9458 16.8562 16.8954 17.116 16.7865 17.353C16.6775 17.5901 16.513 17.7974 16.307 17.9574C15.7679 18.3398 15.3243 18.8415 15.0109 19.4235C14.6974 20.0054 14.5226 20.6519 14.5 21.3125C14.5 24.0046 17.4098 26.1875 21 26.1875C24.5902 26.1875 27.5 24.0046 27.5 21.3125C27.4764 20.6512 27.3002 20.0042 26.9853 19.4222C26.6703 18.8402 26.2251 18.3389 25.6843 17.9574Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-paw-42')) {
    customElements.define('w-icon-paw-42', IconPaw);
}

export class IconRempatori extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16.8007 1.10107L6.00162 11.9001L9.00143 14.9L19.8005 4.10088L16.8007 1.10107Z"
                    fill="#101F41"
                />
                <path
                    d="M15.6011 10.7C16.3969 11.4954 17.4759 11.9422 18.6009 11.9422C19.726 11.9422 20.805 11.4954 21.6008 10.7L25.2006 7.10026L33.0002 14.8998L36 11.9L25.2006 1.10059L15.6011 10.7Z"
                    fill="#3960BF"
                />
                <path
                    d="M22.8007 11.9001C21.6868 13.0139 20.1761 13.6396 18.601 13.6396C17.0257 13.6396 15.515 13.0139 14.4012 11.9001L10.2014 16.0999L21.0008 26.8993L22.8007 25.0994L18.601 20.8996L19.8009 19.6997L24.0007 23.8995L25.8005 22.0996L21.6007 17.8998L22.8007 16.6999L27.0005 20.8996L28.8004 19.0997L24.6006 14.8999L25.8005 13.7L30.0003 17.8998L31.8002 16.0999L25.2006 9.50024L22.8007 11.9001Z"
                    fill="#101F41"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-remppatori-42')) {
    customElements.define('w-icon-remppatori-42', IconRempatori);
}

export class IconShirt extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14.5 9.9375V25.375C14.5 25.5905 14.5856 25.7972 14.738 25.9495C14.8903 26.1019 15.097 26.1875 15.3125 26.1875H26.6875C26.903 26.1875 27.1097 26.1019 27.262 25.9495C27.4144 25.7972 27.5 25.5905 27.5 25.375V9.9375"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M27.5 14.8125H31.5625C31.778 14.8125 31.9847 14.7269 32.137 14.5745C32.2894 14.4222 32.375 14.2155 32.375 14V8.3125C32.375 6.58859 31.6902 4.93529 30.4712 3.71631C29.2522 2.49732 27.5989 1.8125 25.875 1.8125H24.25C24.25 2.67445 23.9076 3.5011 23.2981 4.1106C22.6886 4.72009 21.862 5.0625 21 5.0625C20.138 5.0625 19.3114 4.72009 18.7019 4.1106C18.0924 3.5011 17.75 2.67445 17.75 1.8125H16.125C14.4011 1.8125 12.7478 2.49732 11.5288 3.71631C10.3098 4.93529 9.625 6.58859 9.625 8.3125V14C9.625 14.2155 9.7106 14.4222 9.86298 14.5745C10.0153 14.7269 10.222 14.8125 10.4375 14.8125H14.5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M21 5.0625V8.3125"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M24.25 11.5625H22.625"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-shirt-42')) {
    customElements.define('w-icon-shirt-42', IconShirt);
}

export class IconSmartPhone extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M25.6667 1H17.3333C15.4924 1 14 2.55208 14 4.46667V23.5333C14 25.4479 15.4924 27 17.3333 27H25.6667C27.5076 27 29 25.4479 29 23.5333V4.46667C29 2.55208 27.5076 1 25.6667 1Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <rect
                    x="17.0002"
                    y="5"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    x="17.0002"
                    y="8.375"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    x="17.0002"
                    y="11.75"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    x="17.0002"
                    y="21.875"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    x="20.5"
                    y="5"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    x="20.5"
                    y="8.375"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    x="20.5"
                    y="11.75"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    x="20.5"
                    y="21.875"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    x="24"
                    y="5"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    x="24"
                    y="8.375"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
                <rect
                    x="24"
                    y="21.875"
                    width="2"
                    height="2"
                    rx="1"
                    fill="currentColor"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-smart-phone-42')) {
    customElements.define('w-icon-smart-phone-42', IconSmartPhone);
}

export class IconStroller extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.25 26.1875C14.5962 26.1875 15.6875 25.0962 15.6875 23.75C15.6875 22.4038 14.5962 21.3125 13.25 21.3125C11.9038 21.3125 10.8125 22.4038 10.8125 23.75C10.8125 25.0962 11.9038 26.1875 13.25 26.1875Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M24.625 26.1875C25.9712 26.1875 27.0625 25.0962 27.0625 23.75C27.0625 22.4038 25.9712 21.3125 24.625 21.3125C23.2788 21.3125 22.1875 22.4038 22.1875 23.75C22.1875 25.0962 23.2788 26.1875 24.625 26.1875Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M26.25 18.0625H13.7061C13.3438 18.0625 12.9918 17.9413 12.7062 17.7183C12.4206 17.4954 12.2178 17.1833 12.1298 16.8318L10.8125 11.5625H28.6875"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M25.0193 21.3438L30.3363 7.16516C30.5686 6.54562 30.9844 6.01172 31.5282 5.63481C32.0719 5.2579 32.7178 5.05594 33.3794 5.05591H35.1875"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M15.5488 22.9375H22.3262"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.8125 11.5625C10.8125 8.97664 11.8397 6.49669 13.6682 4.66821C15.4967 2.83973 17.9766 1.8125 20.5625 1.8125V11.5625"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.5625 11.5624L12.1396 6.64844"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.5625 11.5626L15.6485 3.13965"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-stroller-42')) {
    customElements.define('w-icon-stroller-42', IconStroller);
}

export class IconTools extends LitElement {
    render() {
        return html`
            <svg
                width="42"
                height="28"
                viewBox="0 0 42 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16.9992 12.2904L15.8639 11.1594C14.9462 11.5992 13.9148 11.7437 12.9115 11.573C11.9083 11.4024 10.9827 10.9249 10.262 10.2064C9.54141 9.48792 9.06121 8.5637 8.88756 7.56099C8.71391 6.55829 8.85535 5.52641 9.2924 4.60742L10.8362 6.14684C10.9876 6.30197 11.1684 6.42552 11.368 6.51035C11.5675 6.59518 11.7819 6.6396 11.9987 6.64104C12.2156 6.64248 12.4305 6.60091 12.6312 6.51873C12.8318 6.43656 13.0142 6.31541 13.1678 6.1623C13.3213 6.00919 13.4429 5.82716 13.5257 5.62673C13.6084 5.4263 13.6506 5.21146 13.6498 4.99462C13.6489 4.77779 13.6051 4.56328 13.5208 4.36349C13.4366 4.1637 13.3135 3.9826 13.1588 3.83067L11.6162 2.29234C12.5336 1.85357 13.5644 1.70984 14.5669 1.88092C15.5693 2.05199 16.4941 2.52947 17.2141 3.24767C17.9341 3.96587 18.4139 4.8895 18.5874 5.89153C18.761 6.89356 18.6198 7.92475 18.1833 8.84325L19.2342 9.89084"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M24.5956 15.2307L26.1361 16.7669C27.0536 16.3275 28.0846 16.1833 29.0875 16.354C30.0903 16.5246 31.0156 17.0018 31.736 17.7199C32.4565 18.438 32.9368 19.3618 33.1108 20.364C33.2848 21.3663 33.1439 22.3978 32.7076 23.3167L31.1639 21.7784C30.8556 21.4757 30.4404 21.3068 30.0084 21.3085C29.5763 21.3101 29.1624 21.4822 28.8565 21.7872C28.5506 22.0923 28.3774 22.5057 28.3745 22.9377C28.3716 23.3698 28.5393 23.7855 28.8412 24.0945L30.3839 25.6329C29.4665 26.0714 28.4359 26.215 27.4336 26.044C26.4314 25.8729 25.5067 25.3955 24.7868 24.6775C24.0669 23.9595 23.5871 23.0361 23.4134 22.0343C23.2397 21.0325 23.3806 20.0015 23.8167 19.083L22.2762 17.5469"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M9.56545 25.4833C9.33934 25.2585 9.1599 24.9912 9.03746 24.6968C8.91502 24.4024 8.85199 24.0867 8.85199 23.7678C8.85199 23.449 8.91502 23.1333 9.03746 22.8389C9.1599 22.5445 9.33934 22.2772 9.56545 22.0523L14.6517 16.9758C14.804 16.824 15.0103 16.7388 15.2253 16.7388C15.4404 16.7388 15.6466 16.824 15.7989 16.9758L18.0934 19.2628C18.1687 19.3378 18.2283 19.427 18.269 19.5251C18.3097 19.6233 18.3307 19.7285 18.3307 19.8348C18.3307 19.941 18.3097 20.0462 18.269 20.1444C18.2283 20.2425 18.1687 20.3317 18.0934 20.4068L13.0061 25.4833C12.5491 25.9381 11.9306 26.1935 11.2858 26.1935C10.641 26.1935 10.0224 25.9381 9.56545 25.4833Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M25.9682 2.28704L32.7076 9.0037C32.8582 9.1536 32.9778 9.33178 33.0594 9.52801C33.1409 9.72424 33.1829 9.93465 33.1829 10.1472C33.1829 10.3597 33.1409 10.5701 33.0594 10.7663C32.9778 10.9625 32.8582 11.1407 32.7076 11.2906L30.4142 13.5797C30.1096 13.8834 29.697 14.0539 29.2669 14.0539C28.8368 14.0539 28.4243 13.8834 28.1197 13.5797L21.3803 6.86304C21.2296 6.71315 21.1101 6.53497 21.0285 6.33873C20.947 6.1425 20.905 5.93209 20.905 5.71958C20.905 5.50707 20.947 5.29666 21.0285 5.10042C21.1101 4.90419 21.2296 4.72601 21.3803 4.57612L23.6737 2.2892C23.978 1.98527 24.3904 1.81437 24.8205 1.81397C25.2506 1.81356 25.6633 1.98368 25.9682 2.28704Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M24.8209 10.2917L16.8378 18.0116"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;
    }
}
if (!customElements.get('w-icon-tools-42')) {
    customElements.define('w-icon-tools-42', IconTools);
}
